import React, { memo, useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import CommonModal from '../../../../components/common-modal/CommonModal';
import CommonButton from '../../../../components/common-button/CommonButton';
import { MEDIA_TYPES } from '../../../../constants';

import scss from './MediaTypeConflictModal.module.scss';

function MediaTypeConflictModal({ isOpen, incomingType, onClose, onCancel, onConfirm }) {
  const { t } = useTranslation('story');

  const handleConfirm = useCallback(() => {
    onConfirm();
    onClose();
  }, [onConfirm, onClose]);

  const subLabel = incomingType === MEDIA_TYPES.VIDEO ? t('mediaTypeConflictAddVideo') : t('mediaTypeConflictAddImage');

  return (
    <CommonModal isOpen={isOpen} onClose={onClose} wrapperClassName={scss.wrapper} hideCloseIcon>
      <h3 className={scss.title}>{t('mediaTypeConflictTitle')}</h3>
      <span className={scss.subtitle}>{subLabel}</span>

      <div className={scss.actions}>
        <CommonButton type='button' styleColor='secondary' maxWidth={120} onClick={onCancel}>
          {t('discard')}
        </CommonButton>

        <CommonButton type='button' styleColor='primary' maxWidth={140} onClick={handleConfirm}>
          {t('addAnyway')}
        </CommonButton>
      </div>
    </CommonModal>
  );
}

export default memo(MediaTypeConflictModal);
